import { render, staticRenderFns } from "./NewTitleSpotlightModule.vue?vue&type=template&id=7b957e8e&scoped=true"
import script from "./NewTitleSpotlightModule.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewTitleSpotlightModule.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./NewTitleSpotlightModule.vue?vue&type=style&index=0&id=7b957e8e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b957e8e",
  null
  
)

export default component.exports